import React, { useMemo, useState } from "react";
import { Badge, Button, Modal, Typography } from "antd";
import { PlayCircleFilled } from "@ant-design/icons";

const SessionsModal = ({ session, isLive, isDisabled }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false)
  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const iframe = useMemo(() => {
    return isLive ? (
      <iframe
        src={"https://meet.google.com/kzu-fykr-nte"}
        title="Google Meet"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
        allow="camera; microphone; fullscreen"
      />
    ) : (
      <iframe
        src={"https://www.youtube.com/watch?v=RJAJdYw3ctw"}
        title="YouTube Video"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
      />
    )
  }, [isLive]);

  if (isFullScreen) return <div className="z-50 fixed top-0 left-0 w-full h-full bg-[rgba(0,0,0,0.8)]" >
    <div className="aspect-video rounded-2xl overflow-hidden">
      {iframe}
    </div>
    <div className="flex bg-white p-4 absolute top-0 right-0">
      <Button onClick={() => {
        setIsFullScreen(false);

        toggleFullscreen()

      }} >No FullScreen</Button>
    </div>
  </div>

  return (
    <>
      {isLive && (
        <Badge className="absolute top-4 right-4" count={"LIVE at 7:30PM"} />
      )}
      <div
        className="relative flex items-center justify-center w-10 h-10 bg-transparent text-white rounded-full shadow-md hover:bg-blue-600 active:bg-blue-700 transition duration-200 cursor-pointer"
        onClick={() => !isDisabled && showModal()}
        role="button"
      >
        <PlayCircleFilled className="text-5xl text-white" />
      </div>
      <Typography.Text className="absolute bottom-8 text-white font-medium text-3xl">
        {session.name}
      </Typography.Text>

      <Modal
        title={isLive ? "Google Meet Session" : `${session.name}`}
        centered
        open={isModalVisible}
        footer={null}
        onCancel={handleCancel}
        width={"90%"}
      >
        <div className="h-[70vh]">

          {iframe}
          <div className="flex bg-white p-4 absolute bottom-0 right-0">
            <Button onClick={() => {
              setIsFullScreen(true);

              toggleFullscreen()

            }} >FullScreen</Button>
          </div>
        </div>

      </Modal>
    </>
  );
};

export default SessionsModal;


function toggleFullscreen() {
  if (!document.fullscreenElement) {
    // Enter fullscreen
    if (document.documentElement.requestFullscreen) {
      document.documentElement.requestFullscreen();
    } else if (document.documentElement.mozRequestFullScreen) {
      // Firefox
      document.documentElement.mozRequestFullScreen();
    } else if (document.documentElement.webkitRequestFullscreen) {
      // Chrome, Safari, Opera
      document.documentElement.webkitRequestFullscreen();
    } else if (document.documentElement.msRequestFullscreen) {
      // IE/Edge
      document.documentElement.msRequestFullscreen();
    }
  } else {
    // Exit fullscreen
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      // Firefox
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      // Chrome, Safari, Opera
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      // IE/Edge
      document.msExitFullscreen();
    }
  }
}